export const isEmptyObject = (obj: object): boolean => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) return false;
  }
  return true;
};
